import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const ImportantNotice = () => {
  return (
    <section className="py-16 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="border-slate-300 bg-white shadow-lg">
          <CardContent className="p-8">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <AlertCircle className="w-8 h-8 text-slate-700" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Sora, sans-serif' }}>
                  Importante
                </h3>
                <p className="text-slate-700 leading-relaxed">
                  El ingreso al evento está sujeto a validación previa. La participación está destinada
                  exclusivamente a clientes de Elit SA.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ImportantNotice;
